import logUtil from 'utils/log'

/**
 * @param props
 * @param props.hasReachedCheckoutMinimum
 * @param props.hasCartInfo
 * @returns {false}
 */
const shouldShowMinimumToCheckOutCartSelectUtil = (props) => {
  const {
    hasReachedCheckoutMinimum,
    hasCartInfo
  } = props

  const res = (
    !hasReachedCheckoutMinimum ||
    !hasCartInfo
  )

  const debugProps = {
    res,
    props
  }
  logUtil('shouldShowMinimumToCheckOutCartSelectUtil').debug('[start] debugProps=', debugProps)

  return res
}

export default shouldShowMinimumToCheckOutCartSelectUtil
